/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetTasksParams,
  HTTPValidationError,
  PageTaskRead,
  Task,
  TaskCreate,
  TaskUpdate,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new task for an order.
 * @summary Create Task
 */
export const createTask = (taskCreate: TaskCreate, signal?: AbortSignal) => {
  return customInstance<Task>({
    url: `/api/task/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: taskCreate,
    signal,
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: TaskCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: TaskCreate },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: TaskCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createTask(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTask>>
>;
export type CreateTaskMutationBody = TaskCreate;
export type CreateTaskMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Task
 */
export const useCreateTask = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTask>>,
      TError,
      { data: TaskCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: TaskCreate },
  TContext
> => {
  const mutationOptions = getCreateTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many tasks.
 * @summary Get Tasks
 */
export const getTasks = (params: GetTasksParams, signal?: AbortSignal) => {
  return customInstance<PageTaskRead>({
    url: `/api/task/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTasksQueryKey = (params?: GetTasksParams) => {
  return ["api", "task", ...(params ? [params] : [])] as const;
};

export const getGetTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getTasks>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({
    signal,
  }) => getTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTasks>>
>;
export type GetTasksQueryError = ErrorType<void | HTTPValidationError>;

export function useGetTasks<
  TData = Awaited<ReturnType<typeof getTasks>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTasks<
  TData = Awaited<ReturnType<typeof getTasks>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTasks<
  TData = Awaited<ReturnType<typeof getTasks>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tasks
 */

export function useGetTasks<
  TData = Awaited<ReturnType<typeof getTasks>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTasksQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to mark a task as completed.
 * @summary Toggle Task Complete
 */
export const toggleTaskComplete = (
  taskId: number,
  taskUpdate: TaskUpdate,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/task/toggle/${taskId}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: taskUpdate,
    signal,
  });
};

export const getToggleTaskCompleteMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleTaskComplete>>,
    TError,
    { taskId: number; data: TaskUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleTaskComplete>>,
  TError,
  { taskId: number; data: TaskUpdate },
  TContext
> => {
  const mutationKey = ["toggleTaskComplete"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleTaskComplete>>,
    { taskId: number; data: TaskUpdate }
  > = (props) => {
    const { taskId, data } = props ?? {};

    return toggleTaskComplete(taskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleTaskCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleTaskComplete>>
>;
export type ToggleTaskCompleteMutationBody = TaskUpdate;
export type ToggleTaskCompleteMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Toggle Task Complete
 */
export const useToggleTaskComplete = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleTaskComplete>>,
      TError,
      { taskId: number; data: TaskUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleTaskComplete>>,
  TError,
  { taskId: number; data: TaskUpdate },
  TContext
> => {
  const mutationOptions = getToggleTaskCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a task.
 * @summary Update Task
 */
export const updateTask = (taskId: number, taskCreate: TaskCreate) => {
  return customInstance<unknown>({
    url: `/api/task/update/${taskId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: taskCreate,
  });
};

export const getUpdateTaskMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { taskId: number; data: TaskCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { taskId: number; data: TaskCreate },
  TContext
> => {
  const mutationKey = ["updateTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { taskId: number; data: TaskCreate }
  > = (props) => {
    const { taskId, data } = props ?? {};

    return updateTask(taskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTask>>
>;
export type UpdateTaskMutationBody = TaskCreate;
export type UpdateTaskMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Task
 */
export const useUpdateTask = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTask>>,
      TError,
      { taskId: number; data: TaskCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { taskId: number; data: TaskCreate },
  TContext
> => {
  const mutationOptions = getUpdateTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a task.
 * @summary Delete Task
 */
export const deleteTask = (taskId: number) => {
  return customInstance<unknown>({
    url: `/api/task/${taskId}`,
    method: "DELETE",
  });
};

export const getDeleteTaskMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { taskId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { taskId: number },
  TContext
> => {
  const mutationKey = ["deleteTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTask>>,
    { taskId: number }
  > = (props) => {
    const { taskId } = props ?? {};

    return deleteTask(taskId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTask>>
>;

export type DeleteTaskMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Task
 */
export const useDeleteTask = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTask>>,
      TError,
      { taskId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { taskId: number },
  TContext
> => {
  const mutationOptions = getDeleteTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
